import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import Navbar from "./components/Navbar";
import PrivateRoutes from "./features/utils/PrivateRoutes";
import AdminGuide from "./pages/AdminGuide";
import DockerAnsible from "./pages/DockerAnsible";
import ErrorPage from "./pages/ErrorPage";
import Home from "./pages/Home";
import Login from "./pages/Login";
import SQL from "./pages/SQL";
import Traefik from "./pages/Traefik";
import CalendarGenerator from "./pages/apps/CalendarGenerator";
import Course from "./pages/apps/Course";
import MeetingScheduler from "./pages/apps/MeetingScheduler";
import OperationTracker from "./pages/apps/OperationTracker";
import PeerAssessment from "./pages/apps/PeerAssessment";
import Surveys from "./pages/apps/Surveys";
import UserManagement from "./pages/apps/UserManagement";

function App() {
  return (
    <>
      <Router>
        <Navbar />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<PrivateRoutes />}> {/* Wrap protected routes inside PrivateRoutes */}
            <Route path="/" element={<Home />} />
            <Route path="/guides/admin" element={<AdminGuide />} />
            <Route path="/developers/docker-ansible/" element={<DockerAnsible />} />
            <Route path="/developers/traefik/" element={<Traefik />} />
            <Route path="/developers/sql-database/" element={<SQL />} />
            <Route path="/apps/user-management/" element={<UserManagement />} />
            <Route path="/apps/operation-tracker/" element={<OperationTracker />} />
            <Route path="/apps/meeting-scheduler" element={<MeetingScheduler />} />
            <Route path="/apps/calendar-generator" element={<CalendarGenerator />} />
            <Route path="/error" element={<ErrorPage />} />
            <Route path="*" element={<ErrorPage />} />
          </Route>
        </Routes>
      </Router>
    </>
  );
}

export default App;

